import { CONSTANTS } from "../../../../constants/app-constant";
import { socialCityMaster } from "../../../../constants/master-lists";
import {
  getLineGraphFormat,
  getRandomUniqueColor,
} from "../../../Dashboard/data_formatter/format-utils";

export const formatCitySpecificData = (
  d = [],
  graph_type,
  isLineGraph,
  report_type
) => {
  try {
    const dataByReportType = d.graph_data.sort(
      (a, b) => b.post_count.length - a.post_count.length
    );
    if (!dataByReportType) {
      return null;
    }
    if (graph_type === "4" || graph_type === "6") {
      formatCitySpecificDataForLine(d, isLineGraph);
    } else {
      // Calculate unique list of cities of from response
      const cityList = [];
      for (let data of d.graph_data) {
        for (let pd of data.post_count) {
          cityList.push(pd.keyword);
        }
      }
      const cityListUnique = [...new Set(cityList)];

      const graphColors = getRandomUniqueColor(dataByReportType.length);
      let datasets = dataByReportType.map((topicElm, index) => {
        let perTopicCityWisePC = topicElm.post_count;
        // const correctedPerTopicCityWisePC = socialCityMaster.map((city) => {
        const correctedPerTopicCityWisePC = cityListUnique.map((city) => {
          let currentCityPC = perTopicCityWisePC.filter(
            (c) => c.keyword == city
          );
          currentCityPC = currentCityPC && currentCityPC[0];
          return {
            city,
            count: currentCityPC ? currentCityPC.count : 0,
          };
        });
        return {
          label: topicElm.topic_name,
          data: correctedPerTopicCityWisePC,
          backgroundColor: graphColors[index],
        };
      });
      return {
        labels: dataByReportType.map((e) => e.topic_name),
        datasets,
      };
    }
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatNewCitySpecificData = (
  d = [],
  graph_type,
  isLineGraph,
  report_type
) => {
  try {
    const dataByReportType = d.graph_data.sort(
      (a, b) => b.post_data.length - a.post_data.length
    );
    if (!dataByReportType) {
      return null;
    }
    if (graph_type === "4" || graph_type === "6") {
      formatNewCitySpecificDataForLine(d, isLineGraph);
    } else {
      // Calculate unique list of cities of from response
      const cityList = [];
      for (let data of d.graph_data) {
        for (let pd of data.post_data) {
          cityList.push(pd.city);
        }
      }
      const cityListUnique = [...new Set(cityList)];

      const graphColors = getRandomUniqueColor(dataByReportType.length);
      let datasets = dataByReportType.map((topicElm, index) => {
        let perTopicCityWisePC = topicElm.post_data;
        // const correctedPerTopicCityWisePC = socialCityMaster.map((city) => {
        const correctedPerTopicCityWisePC = cityListUnique.map((city) => {
          let currentCityPC = perTopicCityWisePC.filter(
            (c) => c.city == city
          );
          currentCityPC = currentCityPC && currentCityPC[0];
          return {
            city,
            count: currentCityPC ? currentCityPC.count : 0,
          };
        });
        return {
          label: topicElm.topic_name,
          data: correctedPerTopicCityWisePC,
          backgroundColor: graphColors[index],
        };
      });
      return {
        labels: dataByReportType.map((e) => e.topic_name),
        datasets,
      };
    }
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatCitySpecificDataForLine = (d = [], isLineGraph) => {
  try {
    const dataByReportType = d.graph_data.sort(
      (a, b) => b.post_count.length - a.post_count.length
    );
    if (!dataByReportType) {
      return null;
    }
    const graphColors = getRandomUniqueColor(dataByReportType.length);
    let datasets = socialCityMaster.map((city, index) => {
      const data = dataByReportType.map((topicEl) => {
        let perTopicCityWisePC = topicEl.post_count;
        let currentCityP =
          (perTopicCityWisePC.length &&
            perTopicCityWisePC.filter((c) => c.keyword == city)) ||
          [];
        return currentCityP && currentCityP.length ? currentCityP[0].count : 0;
      });
      return {
        label: city,
        data,
        backgroundColor: graphColors[index],
      };
    });
    const lbl = dataByReportType.map((e) => e.topic_name);
    return {
      labels: isLineGraph ? getLineGraphFormat(lbl, true) : lbl,
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatNewCitySpecificDataForLine = (d = [], isLineGraph) => {
  try {
    const dataByReportType = d.graph_data.sort(
      (a, b) => b.post_data.length - a.post_data.length
    );
    if (!dataByReportType) {
      return null;
    }
    let cityData = [];
    dataByReportType.forEach((titleData,index) => {
      let topCount = 10*(index+1);
      titleData.post_data.forEach(tmpCityData => {
        if(tmpCityData.city !== null && !cityData.includes(tmpCityData.city) && topCount >= cityData.length){
          cityData.push(tmpCityData.city)
        }
      });
    })

    const graphColors = getRandomUniqueColor(cityData.length);
    let datasets = cityData.map((city, index) => {
      const data = dataByReportType.map((topicEl) => {
        let perTopicCityWisePC = topicEl.post_data;
        let currentCityP =
          (perTopicCityWisePC.length &&
            perTopicCityWisePC.filter((c) => c.city == city)) ||
          [];
        return currentCityP && currentCityP.length ? currentCityP[0].count : 0;
      });
      return {
        label: city,
        data,
        backgroundColor: graphColors[index],
      };
    });
    const lbl = dataByReportType.map((e) => e.topic_name);
    return {
      labels: isLineGraph ? getLineGraphFormat(lbl, true) : lbl,
      datasets,
    };
    // let datasets = dataByReportType.post_data.map((city,index) => {
    //     let perTopicCityWisePC = city;//.post_data;
    //     let currentCityP =
    //       (perTopicCityWisePC.length && perTopicCityWisePC) || [];
    //     return {
    //       label : city.city,
    //       count : currentCityP && currentCityP.length ? currentCityP[0].count : 0,
    //       backgroundColor: graphColors[index]
    //     }
    //   // return {
    //   //   label: data.map(cityData => cityData.label),
    //   //   data : data.map(cityData => cityData.count),
    //   //   backgroundColor: graphColors[index],
    //   // };
    // });
    // console.log(datasets,"datasets")
    // const lbl = dataByReportType.map((e) => e.topic_name);
    // return {
    //   labels: isLineGraph ? getLineGraphFormat(lbl, true) : lbl,
    //   datasets,
    // };
  } catch (e) {
    console.log(e)
    return {
      labels: [],
      datasets: [],
    };
  }
};
